/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

//-------------To make this control accept a null value to make inputting a number easier put ng-required="true" on the spinner element--------------------------------

module Meevo.Components.Controls {
  "use strict";

  export enum MeevoSpinnerChangeType {
    Arrows = 0,
    Manual = 1
  }

  interface ISpinnerScope extends ng.IScope {
      min: number | string;
      max: number | string;
      disabled: boolean;
      disableTyping?: boolean;
      currentValue: any;
      contentKey: string;
      ngChange: (type) => void;
      required: boolean;
      step?: number;
      tabIndex?: number;
      allowNull?: boolean;

      showRedBorder: boolean;
      availableValues?: (string | number)[];

      increase: any;
      decrease: any;
  }

  export class MeevoSpinner implements angular.IDirective {
    restrict = "E";
    require = "ngModel";
    scope = {
      min: "@",
      max: "@",
      disabled: "=ngDisabled",
      disableTyping: "=?",
      currentValue: "=ngModel",
      contentKey: "@",
      ngChange: "&",
      required: "=ngRequired",
      step: "@?",
      tabIndex: "=?",
      allowNull: "=?",
      availableValues: "=?",
      invalide:"=?"
    };

    templateUrl = "app/components/controls/spinnerTemplate.html";

    link = (scope: ISpinnerScope, element: JQuery, attrs: angular.IAttributes) => {
        let input = element.find("input");
        if (!scope.currentValue && scope.currentValue != 0 && !scope.allowNull) {
            scope.currentValue = scope.min ? scope.min : 0;
        }

        scope.step = scope.step || 1;

        scope.increase = (): void => {
            if (scope.disabled) return;

            if (scope.availableValues instanceof Array && scope.availableValues.length > 0) {
                let index = scope.availableValues.indexOf(scope.currentValue);
                if (index === -1) index = 0;

                if (typeof scope.availableValues[++index] !== 'undefined') {
                    scope.currentValue = scope.availableValues[index];

                    this.$timeout(function () {
                        scope.ngChange({type: MeevoSpinnerChangeType.Arrows});
                    });
                }

                return;
            }

            if (scope.currentValue === "" || scope.currentValue === "-" || scope.currentValue === undefined) {
                scope.currentValue = +scope.max || 0
            }
            if (!scope.disabled && (!scope.max || scope.currentValue < scope.max)) {
                scope.currentValue += +scope.step ;
            }

            this.$timeout(function () {
                scope.ngChange({type: MeevoSpinnerChangeType.Arrows});
            });
        };

        scope.decrease = (): void => {
            if (scope.disabled) return;

            if (scope.availableValues instanceof Array && scope.availableValues.length > 0) {
                let index = scope.availableValues.indexOf(scope.currentValue);
                if (index === -1) index = 0;

                if (typeof scope.availableValues[--index] !== 'undefined') {
                    scope.currentValue = scope.availableValues[index];

                    this.$timeout(function () {
                        scope.ngChange({type: MeevoSpinnerChangeType.Arrows});
                    });
                }

                return;
            }

            if (scope.currentValue === "" || scope.currentValue === "-" || scope.currentValue === undefined) {
                scope.currentValue = +scope.min || 0;
            }
            if (!scope.disabled && (!scope.min || scope.currentValue > scope.min)) {
                scope.currentValue -= +scope.step ;
            }

            this.$timeout(function () {
                scope.ngChange({type: MeevoSpinnerChangeType.Arrows});
            });
        };

        scope.changed = (): void => {
            this.$timeout(function () {
                scope.ngChange({type: MeevoSpinnerChangeType.Manual});
            });
        }

        let debouncedHandler = _.debounce(() => {
            if (scope.currentValue > scope.max) {
                scope.currentValue = parseInt(scope.max as string);
            } else if (scope.currentValue < scope.min) {
                scope.currentValue = parseInt(scope.min as string);
            }
            scope.$apply();
        }, 500);

        scope.$watch('currentValue', currentValue => {
            if(currentValue === '' && scope.allowNull) {
                return;
            }

            if (scope.currentValue != 0 && scope.required && (currentValue == "" || currentValue == "-")) {
                scope.currentValue = "";
                return;
            }
            if (!scope.required && (currentValue == "" || currentValue == "-")) {
                currentValue = 0;
            }
            if (typeof currentValue == "string") {
                scope.currentValue = parseInt(currentValue);
            }

            debouncedHandler();
        });

        input.on("keydown", function (e) {
            switch (e.keyCode) {
                case 40: // down arrow
                    scope.$apply(
                        scope.decrease()
                    );
                    break;
                case 38: // up arrow
                    scope.$apply(
                        scope.increase()
                    );
                    break;
                case 13: // return
                    e.preventDefault();
                    if (window.getSelection().toString) {
                        this.setSelectionRange(0, this.value.length);
                    }
                    break;
            }

        });

        Object.defineProperty(scope, 'showRedBorder', {
            get: () => {
                if(scope.allowNull && scope.currentValue === '') {
                    return false;
                }

                return !scope.currentValue && scope.required
                    || scope.currentValue > scope.max
                    || scope.currentValue < scope.min
                    || scope.invalide
            }
        });
    };
    constructor(private $timeout) {
    }
    static factory(): angular.IDirectiveFactory {
        let directive = ($timeout) => {
            return new MeevoSpinner($timeout);
      };
      directive.$inject = ["$timeout"];
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoSpinner", MeevoSpinner.factory());
}
